import { EditContentOutDto, EditContentInDto } from '../../../types/content.dto'

export const SHOW_CONTENT = 'SHOW_CONTENT'
export const SHOW_CONTENT_SUCCESS = 'SHOW_CONTENT_SUCCESS'
export const SHOW_CONTENT_ERROR = 'SHOW_CONTENT_ERROR'
export const RESET_SHOW_CONTENT = 'RESET_SHOW_CONTENT'

export interface ShowContent {
  type: typeof SHOW_CONTENT
  payload: EditContentOutDto
}


export interface ShowContentSuccess {
  type: typeof SHOW_CONTENT_SUCCESS
  payload: EditContentInDto
}

export interface ShowContentError {
  type: typeof SHOW_CONTENT_ERROR
  payload: string | boolean
}

export interface ResetShowContent {
  type: typeof RESET_SHOW_CONTENT
  payload: null
}
export interface State {
  data: EditContentInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = ShowContent | ShowContentSuccess | ShowContentError | ResetShowContent
